import type { StarRatingValue } from '@lastbrand/web-ui/star-rating-bar'

/** Clamp a 0–5 number, round to the nearest 0.5, and format it for `StarRatingBar`. */
export function toStarRatingValue(value: number): StarRatingValue {
  const clamped = Math.max(0, Math.min(5, value))
  const rounded = Math.round(clamped * 2) / 2
  return rounded.toFixed(1) as StarRatingValue
}
